<template>
    <section class="practice">
        <div class="row">
             <aside class="col-md-3 col-sm-12 cus-sidebar">
                <practiceSidebar />
            </aside>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>

            <div v-if="!isLoading" id="content" class="col-md-9 col-sm-12">
 

                <div class="material-box bg-white">
                    <div class="row content-row">
                        <div class="col-md-12 top-title">
                            <h3>Input Goals by Quarter</h3>
                        </div>
                        <div class="col-md-12">

                            <!-- begin section-container -->
                            <div class="p-b-10 glop_dap">
                                <!-- begin row -->
                                <div class="row">
                                    <div class="col-md-12">
                                        <!-- begin widget -->
                                        <div class="widget-form">
                                            <div class="widget-body p-b-15">
                                                <p>From this screen, you may set your Goals for an entire quarter.<br>
                                                    The numbers you enter will replace any Goals that you set, using Input
                                                    Daily Results.</p>
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <div class="form-group"
                                                                style="padding-top:15px; padding-bottom:15px">
                                                                <label class="control-label">Select Year:</label>
                                                                <b-form-select id="Prefix" v-model="form.year"
                                                                    :options="years">
                                                                </b-form-select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row quarter-btn">
                                                        <div class="col-md-12">
                                                            <label class="m-b-20">Select the quarter you wish to
                                                                manage:</label>
                                                            <div class="form-group text-center qaurter-fields">
                                                                <router-link class="btn btn-default  m-l-5 " :to="{name:'input_quarter_goal',params:{quarter:form,q:1}}">Quarter 1 (Jan. 01 - Mar. 31)</router-link>
                                                                <router-link class="btn btn-default  m-l-5 " :to="{name:'input_quarter_goal',params:{quarter:form,q:2}}">Quarter 2 (April 01 - June 30)</router-link> 
                                                            </div>
                                                            <div class="form-group text-center qaurter-fields">
                                                                <router-link class="btn btn-default  m-l-5 " :to="{name:'input_quarter_goal',params:{quarter:form,q:3}}">Quarter 3 (July 01 - Sep. 30)</router-link> 
                                                                <router-link class="btn btn-default  m-l-5 " :to="{name:'input_quarter_goal',params:{quarter:form,q:4}}">Quarter 4 (Oct. 01 - Dec. 31)</router-link> 
                                                            </div>
                                                        </div>
                                                    </div>

                                            </div>
                                        </div>
                                        <!-- end widget -->
                                    </div>
                                </div>
                                <!-- end row -->
                            </div>
                        </div>
                        <!-- end section-container -->
                    </div>
                </div>
                <!-- begin #footer -->
                <div id="footer" class="footer"> <span class="pull-right"> <a href="javascript:;" class="btn-scroll-to-top"
                            data-click="scroll-top"> <i class="fa fa-arrow-up"></i> <span class="hidden-xs">Back to
                                Top</span> </a> </span> © 2023 <b>Goals Tracking System</b> All Right Reserved </div>
                <!-- end #footer -->
            </div>
        </div>
    </section>
</template>

<script>
import practiceSidebar from "./../../Practice/components/Sidebar.vue";
import moment from 'moment'
export default {
    name: "quarter_dashboard",
    components: {
        practiceSidebar
    },
    data() {
        return {
            isLoading: false,
            years: [],
            loginUser: {},
            form:{
                year:moment().format('Y')
            }
        }
    },
    methods: {
        setYears() {
            let currentYear = parseInt(moment().format('Y'))+ 1;
            for (let index = 2018; index <= currentYear; index++) {
                this.years.push(index) 
            }
        }
    },
    mounted() {
        this. setYears() 
        this.loginUser = JSON.parse(localStorage.getItem('userDetails'));
    },

}

</script>

<style>
@media (max-width: 500px) {
    .qaurter-fields {
        flex-direction: column;
    }
    .qaurter-fields .btn-default {
        width: 100%;
    }
    .qaurter-fields .btn-default:nth-child(1) {
        margin-bottom: 15px;
    }
}
</style>